__turbopack_context__.v({
  "onlyTextContainer": "AgencyHomeTextOnlySlider-module-scss-module__Q0A2Xa__onlyTextContainer",
  "onlyTextContainerSection": "AgencyHomeTextOnlySlider-module-scss-module__Q0A2Xa__onlyTextContainerSection",
});
